module.exports = __webpack_public_path__ + "static/media/closedDoor.7ae3b42b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/closedDoor.jpg
// module id = 55
// module chunks = 0